import React from 'react'
import { Card, Row, Button, Col } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import {
  currencyFormat,
  trackGTMEvents,
  IS_BROWSER,
  application,
  enablePlpRedesign,
  enablePdpRedesign,
} from 'src/utils'
import { pageNames } from 'src/routes/pathParams'
import ImageComponent from '../../ImageComponent'
import { i18nTranslate } from 'src/utils'
import { catalogContainer } from 'src/models/Catalog'
import './styles.scss'
import { customerContainer } from 'src/models'
import { addCartIcon } from '../V2ProductQuantityAndButtons/fixture'

class ProductReplacement extends React.Component {
  constructor(props, context) {
    super(props)
  }

  getPrice = (custompriceValue = '') => {
    const formattedPrice = currencyFormat({
      price: custompriceValue,
    })
    return formattedPrice
  }

  /* fix for ADA as child anchor tags are also included in tab navigation
  *@param {string} domainName 
  inside child elements */
  isBAorPreferred = () => {
    let accountType = ''
    if (IS_BROWSER) {
      accountType = customerContainer.profileResponse?.accounts?.type || ''
    } else {
      accountType = this?.context?.customerType
    }
    return (
      accountType === 'Brand Affiliate' ||
      accountType === 'Brand Affiliate - Business Entity' ||
      accountType === 'Preferred Customer/Member' ||
      false
    )
  }
  getTotalPrice = priceFacets => {
    if (this.isBAorPreferred()) {
      return priceFacets?.['Wholesale Price']
    } else {
      return priceFacets?.['Regular Price']
    }
  }
  getDomainWithLocale = url => {
    try {
      const parsedUrl = new URL(url)
      const pathnameParts = parsedUrl?.pathname?.split('/').filter(Boolean)
      const locale = pathnameParts?.slice(0, 2).join('/')
      return `${parsedUrl.origin}/${locale}`
    } catch (error) {
      console.error('Invalid URL:', error)
      return ''
    }
  }
  handleReplacementProductClick = ({
    price = '',
    url = '',
    replacementProductName = '',
    replacementProductId = '',
    categoryName = '',
    isQuickview = false,
  }) => {
    let domainName = ''
    if (IS_BROWSER) {
      domainName = window?.location?.href
    } else {
      domainName = new URL(location?.href)
    }
    const domainWithLocal = this.getDomainWithLocale(domainName)
    const cliclUrl = `${domainWithLocal}${url}`
    const isRedesign = enablePlpRedesign() || enablePdpRedesign()
    const productObj = {
      item_type: 'replacement_product',
      item_view: isQuickview ? 'PLP quickview' : 'PDP',
      page_url: domainName,
      click_url: cliclUrl,
      ...(isRedesign
        ? {
            item_name: replacementProductName,
            item_id: replacementProductId,
            item_price: price,
            item_brand: 'Nuskin',
            item_category: categoryName,
            discontinued_item_name: this.props?.product?.name || '',
            discontinued_item_id: this.props?.product?.skuId || '',
          }
        : {
            name: replacementProductName,
            id: replacementProductId,
            price: price,
            brand: 'Nuskin',
            category: categoryName,
            discontinued_product_name: this.props?.product?.name || '',
            discontinued_product_id: this.props?.product?.skuId || '',
          }),
    }
    trackGTMEvents({
      event: 'replaced_product_click',
      ecommerce: {
        click: {
          actionField: {
            list: '',
            action: 'click',
            products: [productObj],
          },
        },
      },
    })
    catalogContainer.replacementProductClick = true
    catalogContainer.isQuickview = isQuickview
  }

  render() {
    const { product = {}, isQuickview = false } = this.props
    const recommendedProducts = this.props?.replacementProduct || {}
    const replacementProductTitle =
      recommendedProducts?.sku?.[0]?.properties?.title || ''
    const imageUrl = recommendedProducts?.sku?.[0]?.properties?.imageURL || ''
    const priceInfo = recommendedProducts?.sku?.[0]?.prices?.[0]?.price || ''
    const price = priceInfo ? this.getPrice(priceInfo) : ''
    const isPdpRedesignEnabled = enablePdpRedesign()
    const replacementTitle = isPdpRedesignEnabled
      ? i18nTranslate('RedesignReplacementTitle', 'Try this instead', {
          nameSpace: 'ssr-resource',
        })
      : i18nTranslate('pdp.ReplacementTitle', 'TRY THIS INSTEAD!', {
          nameSpace: 'ssr-resource',
        })

    const getAddToCartButtonText = () => {
      return i18nTranslate('override_text_addToCart', 'Add to Cart', {
        nameSpace: 'ssr-resource',
      })
    }
    let description =
      recommendedProducts?.sku?.[0]?.properties?.description || ''

    const hasMoreThanOneSku = (recommendedProducts?.sku?.[0]?.length || 1) > 1
    const skuId = recommendedProducts?.sku?.[0]?.identifier || ''
    const totalPrice = this.getTotalPrice(
      recommendedProducts?.sku?.[0].priceFacets
    )
    const replacementProductPrice = this.getPrice(totalPrice)
    const skuSlug = recommendedProducts?.properties?.slug || ''
    const variantParameter = skuSlug || skuId || ''
    const productOrSlugId = skuSlug
      ? skuSlug
      : recommendedProducts?.sku?.[0]?.identifier || ''
    const shouldAppendVariant = hasMoreThanOneSku && variantParameter

    let url = ''
    if (shouldAppendVariant) {
      url = `${pageNames.product}/${productOrSlugId}?variant=${variantParameter}`
    } else {
      url = `${pageNames.product}/${productOrSlugId}`
    }
    const alt = i18nTranslate(
      'pdp.defaultAltReplacementProductImg',
      'Replacement Product image',
      {
        nameSpace: 'ssr-resource',
      }
    )
    const replacementProductStatus =
      recommendedProducts?.sku?.[0]?.properties?.productStatus
        ?.toLowerCase?.()
        .trim() === 'discontinued'
    const props = {
      isReplacementProduct: true,
      replacementProduct: recommendedProducts,
    }
    let messageToDisplay = ''
    let replacementPdpStatus =
      recommendedProducts?.sku?.[0]?.properties?.productStatus
        ?.toLowerCase?.()
        .trim()
    const dangerousGoodsVal =
      recommendedProducts?.sku?.[0]?.properties?.dangerousGoods || false
    replacementPdpStatus =
      dangerousGoodsVal === 'true' || dangerousGoodsVal === true
        ? 'dangerous'
        : replacementPdpStatus

    switch (replacementPdpStatus) {
      case 'test':
        messageToDisplay = i18nTranslate(
          'bundle.testSku',
          'This is a test sku',
          {
            nameSpace: 'ssr-resource',
          }
        )
        break
      case 'preview product':
      case 'preview':
        messageToDisplay = i18nTranslate(
          'bundle.preview',
          'Preview product and will be launched soon',
          {
            nameSpace: 'ssr-resource',
          }
        )
        break
      case 'stopped':
        messageToDisplay = i18nTranslate(
          'bundle.stopped',
          'This product is temporarily stopped',
          {
            nameSpace: 'ssr-resource',
          }
        )
        break
      case 'replacement':
        messageToDisplay = i18nTranslate(
          'bundle.replacement',
          'This is a replacement product and not available for purchase',
          {
            nameSpace: 'ssr-resource',
          }
        )
        break
      case 'bundleonly':
      case 'bundle only':
        messageToDisplay = i18nTranslate(
          'pdp.bundleOnly',
          'Item not available for individual purchase',
          {
            nameSpace: 'ssr-resource',
          }
        )
        break
      case 'dangerous':
        messageToDisplay = i18nTranslate(
          'pdp.dangerousGoodsError',
          'Dangerous Goods cannot be added to Cart or Subscribed',
          {
            nameSpace: 'ssr-resource',
          }
        )
        break
    }
    const replacementPrice = replacementProductPrice
      ? replacementProductPrice
      : price

    const skuData = recommendedProducts?.sku?.[0] || {}
    const replacementInventory = skuData?.inventory || ''
    const replacementInventoryStatus =
      skuData?.properties?.inventoryStatus || ''
    const inventoryProperties = skuData?.inventoryProperties || {}

    const isReplacementOutOfStock =
      replacementInventory?.toLowerCase() === 'out of stock' ||
      replacementInventoryStatus?.toLowerCase() === 'out of stock' ||
      inventoryProperties?.available === false ||
      inventoryProperties?.outOfStockThreshold >=
        (inventoryProperties?.atpQty || 0)

    return (
      <div className={isPdpRedesignEnabled ? 'mt-4' : ''}>
        {isPdpRedesignEnabled && (
          <Card.Title className="redesign-replacementContTitle">
            {replacementTitle}
          </Card.Title>
        )}
        <Card
          className={`mb-3 ${isPdpRedesignEnabled ? 'redesign-replacement-product' : 'replacement-product'}`}>
          <Row
            className={`${
              replacementProductStatus ? 'replacement-product-discontinued' : ''
            } ${isPdpRedesignEnabled ? 'd-flex flex-column' : 'g-0 p-3'}`}>
            <Col
              {...(isPdpRedesignEnabled ? {} : { md: 4 })}
              className={
                isPdpRedesignEnabled ? 'd-flex justify-content-center' : ''
              }>
              <Link
                to={url}
                className="text-decoration-none"
                onClick={() => {
                  this.handleReplacementProductClick({
                    price: price,
                    url,
                    replacementProductName: replacementProductTitle,
                    replacementProductId:
                      recommendedProducts?.sku?.[0]?.identifier,
                    categoryName:
                      recommendedProducts?.[0]?.category?.[0]?.properties
                        ?.name || '',
                    isQuickview: isQuickview,
                  })
                }}>
                {application.isMobile && !isPdpRedesignEnabled && (
                  <Card.Title className="replacementContTitle text-center">
                    {replacementTitle}
                  </Card.Title>
                )}
                <div className="discontinue-parent-div">
                  {replacementProductStatus && (
                    <div className="replament-product-discontinued-text">
                      {i18nTranslate(
                        'pdp.ItemDiscontinued',
                        'Item Discontinued',
                        {
                          nameSpace: 'ssr-resource',
                        }
                      )}
                    </div>
                  )}

                  <ImageComponent
                    testId="qa-replacement-discontinued-image"
                    className="plp-product-image"
                    src={imageUrl}
                    alt={alt}
                    optimizeImage={true}
                    height={'200px'}
                    width={'200px'}
                  />
                </div>
              </Link>
            </Col>
            <Col {...(isPdpRedesignEnabled ? {} : { md: 8 })} className="p-0">
              <Card.Body className="discontinued">
                <Link
                  to={url}
                  onClick={() => {
                    this.handleReplacementProductClick({
                      price: price,
                      url,
                      replacementProductName: replacementProductTitle,
                      replacementProductId:
                        recommendedProducts?.sku?.[0]?.identifier,
                      categoryName:
                        recommendedProducts?.[0]?.category?.[0]?.properties
                          ?.name || '',
                      isQuickview: isQuickview,
                    })
                  }}
                  className="text-decoration-none">
                  {!application.isMobile && !isPdpRedesignEnabled && (
                    <Card.Title className="replacementContTitle">
                      {replacementTitle}
                    </Card.Title>
                  )}
                  <Card.Text
                    className={
                      isPdpRedesignEnabled
                        ? 'redesign-replacementPdpTitle'
                        : 'replacementPdpTitle'
                    }>
                    {replacementProductTitle}
                  </Card.Text>
                  {isPdpRedesignEnabled && (
                    <Card.Text className="redesign-replacementPdpPrice">
                      {replacementPrice}
                    </Card.Text>
                  )}
                  {description && (
                    <Card.Text
                      className={
                        isPdpRedesignEnabled
                          ? 'redesign-card-description'
                          : 'card-description'
                      }>
                      {description}
                    </Card.Text>
                  )}
                  {messageToDisplay && replacementPdpStatus !== 'dangerous' && (
                    <Card.Text
                      className={
                        isPdpRedesignEnabled
                          ? 'redesign-availability-text mt-3 mb-2'
                          : 'availability-text-no-bg'
                      }
                      aria-live="polite"
                      role="alert">
                      {messageToDisplay}
                    </Card.Text>
                  )}
                </Link>
                <Button
                  className={
                    isPdpRedesignEnabled
                      ? 'redesignAddToCardBtn'
                      : 'addToCardBtn'
                  }
                  disabled={
                    replacementProductStatus ||
                    isReplacementOutOfStock ||
                    (messageToDisplay != '' &&
                      replacementPdpStatus != 'test' &&
                      replacementPdpStatus != 'dangerous')
                  }
                  onClick={() => this.props.handleAddToCartClick(props)}>
                  {isPdpRedesignEnabled ? (
                    <>
                      {addCartIcon()}
                      {getAddToCartButtonText()}
                    </>
                  ) : (
                    <>
                      {getAddToCartButtonText()?.toUpperCase()}{' '}
                      {replacementPrice}
                    </>
                  )}
                </Button>
              </Card.Body>
            </Col>
          </Row>
        </Card>
      </div>
    )
  }
}

export { ProductReplacement }
